/*
 *  Copyright (c) Qwoach LLC 2022. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 9/2/2022
 */

import BaseAnalytics from "@qwoach/analytics/dist/common/BaseAnalytics"
import axios from "axios"
import {asBase64, delay} from "@/utils/helpers";


export default class EnchargeAnalytics extends BaseAnalytics {

	userData = {}



	setup(apiKey, writeKey){
		this.init()
		this.apiKey = apiKey
	}


	setUserId(userId){
		console.log("EnchargeAnalytics.setUserId: ", userId)
		this.userId = userId
		this.userData.userId = userId
		return this.setUserProps({userId: userId})
	}

	setEmail(email){
		console.log("EnchargeAnalytics.setEmail: ", email)
		return this.setUserProps({email: email})
	}

	async setUserProps(props){
		props = {
			userId: this.userId,
			...props
		}
		this.userData = {
			...this.userData,
			...props
		}
		console.log("EnchargeAnalytics.setUserProps: ", props)
		this._tracker().identify(props);
	}

	// async fetchCurrentUserData(props){
	// 	let user
	// 	try{
	// 		let idName
	// 		let idValue
	// 		if(this.userId){
	// 			idName = "userId"
	// 			idValue = this.userId
	// 		} else {
	// 			idName = "enchargeAnonymousId"
	// 			idValue = await this.getAnonymousId()
	// 		}
	// 		user = await Vue.config.globalProperties.$dataManager.apiGetEnchargeUniqueFields({idName: idName, idValue: idValue, props: props})
	// 	} catch (e) {
	// 		console.error(e)
	// 	}
	// 	return user || {}
	// }

	async setUserPropsOnce(props){
		// let userData = await this.fetchCurrentUserData(props)
		let finalProps = {}
		// Object.keys(props).forEach(key => {
		// 	if(!userData[key]){
		// 		finalProps[key] = props[key]
		// 	}
		// })
		let idName
		let idValue
		if(this.userId){
			idName = "userId"
			idValue = this.userId
		} else {
			idName = "enchargeAnonymousId"
			idValue = await this.getAnonymousId()
		}
		try{
			finalProps = await this.getUnique({idName: idName, idValue: idValue, props: props})
			//no longer using server side as it clatters server log a lot
			//await Vue.config.globalProperties.$dataManager.apiGetEnchargeUniqueFields({idName: idName, idValue: idValue, props: props})
		} catch (error){
			console.error(error)
			finalProps = props
		}


		console.log("EnchargeAnalytics.setUserPropsOnce: finalProps = ", finalProps, ", props = ", props)
		await this.setUserProps(finalProps)
	}

	async getUnique({idName, idValue, props}){
		let enchargeConfig = {apiKey: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhY2NvdW50SWQiOjE2MTUzLCJuYW1lIjoiYmFzZSJ9.pgM0OpFLxTZZckK1LMpU48qQzVXTwg1pF8aVYm5QQlw"}
		let url = `https://api.encharge.io/v1/people?people[0][${idName}]=${idValue}&token=${enchargeConfig.apiKey}`
		url = asBase64(url)
		let proxyUrl = `https://proxy.qwoach.com/api/proxy?url=${url}`
		console.log("EnchargeAnalytics.getUnique: url = ", url, ", proxyUrl = ", proxyUrl)
		let response = await axios.get(proxyUrl)
		let userData = response.data.users[0] || {}

		console.log("EnchargeAnalytics.getUnique userData = ", userData)
		console.log("EnchargeAnalytics.getUnique props = ", props)
		if(typeof props === "string"){
			props = JSON.parse(props)
		}
		let finalProps = {}
		Object.keys(props).forEach(key => {
			if(!userData[key]){
				finalProps[key] = props[key]
			}
		})

		return finalProps
	}


	init() {
		console.log("EnchargeWrapper init")
		this.disableForms()
		// this.disablePageview()
		this.setupEncharge()

	}


	disableForms() {
		if (!window.EncTracking) window.EncTracking = {};
		window.EncTracking.recordForms = false;
	}

	disablePageview() {
		if (!window.EncTracking) window.EncTracking = {};
		window.EncTracking.recordPageViews = false;
		window.EncTracking.recordPageViewsOnExit = false;
	}

	_tracker() {
		return window.EncTracking
	}

	trackEvent(eventName, properties, userData) {
		if(eventName === "Error"){
			return
		}
		this.userData = {
			...this.userData,
			...(userData || {})
		}
		let data = {
			name: eventName,
			properties: properties,
			user: userData || this.userData
		}
		console.log("EnchargeAnalytics.trackEvent: ", data)
		this._tracker().track(data);
	}


	async trackPageView(props) {
		console.log("EnchargeAnalytics.trackPageView: ", props)
		await this.waitLoadCompleted()
		this._tracker().client.recordEvent('pageviews', {
			page: {
				url: props.page_location,
				title: props.page_title,
				path: props.page_path
			}
		})
	}

	enableOptIn() {
		window.EncTracking.optIn();
	}

	clearCookie() {
		window.EncTracking.clearCookies();
	}

	async getAnonymousId() {
		await this.waitLoadCompleted()
		return window.EncTracking.getId()
	}

	async waitLoadCompleted(){
		while(typeof window.EncTracking.getId !== "function") {
			await delay(100)
		}
	}



	setupEncharge(){
		!function () {
			if (!window.EncTracking || !window.EncTracking.started) {
				window.EncTracking = Object.assign({}, window.EncTracking, {
					queue: window.EncTracking && window.EncTracking.queue ? window.EncTracking.queue : [],
					track: function (t) {
						this.queue.push({type: "track", props: t})
					},
					identify: function (t) {
						this.queue.push({type: "identify", props: t})
					},
					started: !0
				});
				var t = window.EncTracking;
				t.writeKey = "2qhVP8mLnhDaif4k6kvTQdKqm", t.hasOptedIn = true, t.shouldGetConsent = true, t.hasOptedIn && (t.shouldGetConsent = !1), t.optIn = function () {
					t.hasOptedIn = !0, t && t.init()
				}, t.optOut = function () {
					t.hasOptedIn = !1, t && t.setOptOut && t.setOptOut(!0)
				};
				var n = function (t) {
					var n = document.createElement("script");
					n.type = "text/javascript", n.async = void 0 === t || t, n.src = "https://resources-app.encharge.io/encharge-tracking.min.js";
					var e = document.getElementsByTagName("script")[0];
					e.parentNode.insertBefore(n, e)
				};
				"complete" === document.readyState ? n() : window.attachEvent ? window.attachEvent("onload", n) : window.addEventListener("load", n, !1)
			}
		}();
	}
}
